import { Button } from "@ravalmatic/catafractum-utils";
import { AudioManager } from "../../../AudioManager";
import { GameManager } from "../../../GameManager";
import { GameVars } from "../../../GameVars";

export class BurgerMenu extends Phaser.GameObjects.Container {

    private static readonly SPACING = 92;
    private static readonly VERTICAL_OFFSET = 12;

    private settingsBtn: Button;
    private musicOnBtn: Button;
    private musicOffBtn: Button;
    private sfxOnBtn: Button;
    private sfxOffBtn: Button;
    private infoBtn: Button;
    private resetBtn: Button;
    private homeBtn: Button;
    private menuItems: Button[];
    private isOpen = false;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.resetBtn = this.createButton(scene, "btn_reset", () => {
            GameManager.enterBoardScene();
            AudioManager.playSound("click");
        });
        this.infoBtn = this.createButton(scene, "btn_info", () => {
            console.log("Info button pressed");
        });
        this.homeBtn = this.createButton(scene, "btn_home", () => {
            GameManager.enterSplashScene();
            AudioManager.playSound("click");
        });
        this.musicOnBtn = this.createButton(scene, "btn_soundtrack_on", () => this.onMusicButton());
        this.musicOffBtn = this.createButton(scene, "btn_soundtrack_off", () => this.onMusicButton());
        this.sfxOnBtn = this.createButton(scene, "btn_sfx_on", () => this.onSfxButton());
        this.sfxOffBtn = this.createButton(scene, "btn_sfx_off", () => this.onSfxButton());

        this.settingsBtn = new Button(scene, 0, 0, "texture_atlas_1", "btn_settings");
        this.settingsBtn.setInflationTween(1.05);
        this.settingsBtn.on("pointerup", this.toggle, this);

        this.menuItems = [this.musicOnBtn, this.sfxOnBtn, this.infoBtn, this.resetBtn, this.homeBtn];
        this.add(this.menuItems);
        this.add([this.musicOffBtn, this.sfxOffBtn, this.settingsBtn]);
        this.bringToTop(this.settingsBtn);
        this.refreshAudioButtons();
    }

    private createButton(scene: Phaser.Scene, frame: string, callback: () => void): Button {

        const button = new Button(scene, 0, 0, "texture_atlas_1", frame);
        button.setInflationTween(1.05);
        button.setVisible(false);
        button.onUp(callback, this);
        return button;
    }

    private toggle(): void {
        this.isOpen ? this.closeMenu() : this.openMenu();
    }

    private openMenu(): void {

        this.isOpen = true;
        this.refreshAudioButtons();

        this.menuItems.forEach((button, index) => {
            const variants = this.getVariants(button);
            variants.forEach((variant) => {
                variant.y = 0;
                variant.setVisible(true);
                variant.setInteractive();
            });
            this.scene.tweens.add({
                targets: variants,
                y: (index + 1) * BurgerMenu.SPACING + BurgerMenu.VERTICAL_OFFSET,
                ease: Phaser.Math.Easing.Back.Out,
                duration: 300,
                delay: index * 50
            });
        });

        AudioManager.playSound("click");
    }

    private closeMenu(): void {

        this.isOpen = false;
        this.menuItems.forEach((button) => {
            const variants = this.getVariants(button);
            variants.forEach((variant) => variant.disableInteractive());
            this.scene.tweens.add({
                targets: variants,
                y: 0,
                ease: Phaser.Math.Easing.Cubic.In,
                duration: 200,
                onComplete: () => variants.forEach((variant) => variant.setVisible(false))
            });
        });
    }

    private onMusicButton(): void {
        AudioManager.toggleMusicState();
        this.refreshAudioButtons();
        AudioManager.playSound("click");
    }

    private onSfxButton(): void {
        AudioManager.toggleSfxState();
        this.refreshAudioButtons();
    }

    private refreshAudioButtons(): void {
        this.musicOnBtn?.setVisible(this.isOpen && !GameVars.gameData.musicMuted);
        this.musicOffBtn?.setVisible(this.isOpen && GameVars.gameData.musicMuted);
        this.sfxOnBtn?.setVisible(this.isOpen && !GameVars.gameData.sfxMuted);
        this.sfxOffBtn?.setVisible(this.isOpen && GameVars.gameData.sfxMuted);
    }

    private getVariants(button: Button): Button[] {
        if (button === this.musicOnBtn) {
            return [this.musicOnBtn, this.musicOffBtn];
        }
        if (button === this.sfxOnBtn) {
            return [this.sfxOnBtn, this.sfxOffBtn];
        }
        return [button];
    }
}
